import ScalarMarkdownSummary_vue_vue_type_script_setup_true_lang_default from "./ScalarMarkdownSummary.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                          */
//#region src/components/ScalarMarkdown/ScalarMarkdownSummary.vue
var ScalarMarkdownSummary_default = ScalarMarkdownSummary_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMarkdownSummary_default as default };

//# sourceMappingURL=ScalarMarkdownSummary.vue.js.map